const selector = {
    form: '#form_checkout_redirect',
};

export {selector};